import React, { useRef, useState, useContext, Fragment } from 'react';
import SingleVideoSlide from './singleVideoSlide';
import Carousel from '../../components/carousel';
import PageContext from '../../contexts/pageContext';

import useCoursePromotionPage from './styles';
import { wordBreakValue } from '../../utils/cssUtils';

function CoursePromotionPage({ sectionData, extraProps = {}, sectionIndex }) {
  const {
    layout: { containerWidth },
    countryCode,
    currencySymbol,
    isMobile
  } = useContext(PageContext);

  const classes = useCoursePromotionPage({
    containerWidth,
    isMobile,
    wordBreakValue: wordBreakValue(countryCode)
  });

  return (
    <div className={classes.webinarSuperContainer}>
      <div className={classes.videoTestimonialContainer}>
        <div className={classes.sectionContainer}>
          <SingleVideoSlide
            data={sectionData.components[0].metadata}
            webinarCtaClick={extraProps.webinarCtaClick}
            conversions={extraProps.conversions}
            sectionIndex={sectionIndex}
            countryCode={countryCode}
            currencySymbol={currencySymbol}
          />
        </div>
      </div>
    </div>
  );
}

export default CoursePromotionPage;
